import React from "react"

import { Form, Formik } from "formik"

import { ValueFormat } from "~tailwindui/types/enums"

import { handleFailure } from "~tailwindui/Form"

import formatValue from "src/formatValue"

import { gql, useMutation } from "hooks/urql"

import {
  FormFailures,
  SubmitButton,
} from "components/Forms/Formik/hookComponents"
import ModalWithProvidedBody from "components/ModalWithProvidedBody"

const RebillSession = ({ sessionId, billedRateCents, sessionRateCents }) => {
  const [, runMutation]: any[] = useMutation(rebillSessionMutation)

  const handleSubmit = (values, actions) => {
    runMutation(values)
      .then(
        response => {
          const { failures } = response.data.rebillSession
          if (failures.length > 0) {
            handleFailure(actions, failures)
          } else {
            window.location.reload()
          }
        },
        () => handleFailure(actions)
      )
      .catch(() => handleFailure(actions))
  }

  return (
    <ModalWithProvidedBody
      modalTitle="Re-Bill Session at A Different Rate"
      buttonText="Re-Bill Session"
      buttonClassName="btn btn-danger btn-sm"
    >
      {({ closeModal }) => (
        <Formik initialValues={{ sessionId }} onSubmit={handleSubmit}>
          <Form>
            <div className="modal-body">
              <p>
                Session was previously billed at{" "}
                {formatValue(billedRateCents / 100, ValueFormat.Currency)} per
                hour.
              </p>
              <p>
                Session will be re-billed at the current rate of{" "}
                {formatValue(sessionRateCents / 100, ValueFormat.Currency)} per
                hour.
              </p>
              <p>
                If you want to bill this session at a different rate,
                temporarily update the study group's rate before rebilling.
              </p>
            </div>
            <div className="modal-footer flex-column">
              <FormFailures />
              <div className="d-flex justify-content-between w-full">
                <button
                  type="button"
                  onClick={closeModal}
                  className="btn btn-info"
                >
                  Cancel
                </button>
                <SubmitButton
                  className="btn btn-danger"
                  text={`Bill at ${formatValue(
                    sessionRateCents / 100,
                    ValueFormat.Currency
                  )}`}
                />
              </div>
            </div>
          </Form>
        </Formik>
      )}
    </ModalWithProvidedBody>
  )
}

const rebillSessionMutation = gql`
  mutation RebillSession($sessionId: ID!) {
    rebillSession(sessionId: $sessionId) {
      failures {
        message
      }
    }
  }
`

export default RebillSession
